import app from "../_app";

[...document.querySelectorAll('.js-countdown')].map((countdown) => {
    const interval = setInterval(() => {
        const now = new Date();
        const time = new Date(countdown.dataset.time * 1000);
        let difference = new Date(time.getTime() - now.getTime());

        if(difference.getTime() >= 0) {
            const newInnerText = [];

            if(difference.getUTCHours() > 0) {
                const hoursTranslation = app.translationHelper(`general.dates.hours.${difference.getUTCHours() === 1 ? 'one' : 'other'}`);

                newInnerText.push(`${difference.getUTCHours()} ${hoursTranslation}`);
            }

            if(difference.getUTCMinutes() >= 0) {
                const minutesTranslation = app.translationHelper(`general.dates.minutes.${difference.getUTCMinutes() === 1 ? 'one' : 'other'}`);

                newInnerText.push(`${difference.getUTCMinutes()} ${minutesTranslation}`);
            }

            countdown.innerText = newInnerText.join(` ${app.translationHelper('general.and')} `);
        } else {
            clearInterval(interval);
        }
    }, 1000);
});
